<template>
	<div class="human-container" :key="getKey">
        <template>
            <v-tabs v-if="!mobile" v-model="tab">
                <v-tab>Описание</v-tab>
                <v-tab  :disabled="getLoadingCurrentSystemId" @click="tabClick(true)">
                    Свойства норма
                    <v-overlay :value="getLoadingCurrentSystemId" absolute>
                        <v-progress-circular indeterminate size="30" />
                    </v-overlay>
                </v-tab>
                <v-tab :disabled="getLoadingCurrentSystemId" @click="tabClick(false)">
                    Свойства патология

                    <v-overlay :value="getLoadingCurrentSystemId" absolute>
                        <v-progress-circular indeterminate size="30" />
                    </v-overlay>
                </v-tab>
                <!-- <v-tab>Показатели</v-tab> -->
            </v-tabs>
            <v-tabs v-else v-model="tab" vertical>
                <v-tab>Описание</v-tab>
                <v-tab @click="setKey()">Свойства норма</v-tab>
                <v-tab @click="setKey()">Свойства патология</v-tab>
                <!-- <v-tab>Показатели</v-tab> -->
            </v-tabs>
        </template>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <Redactor />
            </v-tab-item>
            <v-tab-item>
                <Property :isnormal="isnormal" />
            </v-tab-item>
            <v-tab-item>
                <Property :isnormal="isnormal" />
            </v-tab-item>
            <!-- <v-tab-item>
                <EditorSomaticParametrs />
            </v-tab-item> -->
        </v-tabs-items>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Redactor from "@/components/Redactor/Redactor.vue";
import "./index.scss";
import Property from "@/components/Property/Property.vue";
import EditorSomaticParametrs from "@/components/EditorSomaticParametrs/index.vue";

export default {
	name: "Human",
	components: {
		Redactor,
		Property,
		EditorSomaticParametrs
	},
	data() {
		return {
            isnormal: false,
			mobile: false,
			expanded: true,
			tab: null,
		};
	},
	computed: {
		...mapGetters({
            getKey: "tree/getKey",
            getLoadingCurrentSystemId: "tree/getLoadingCurrentSystemId"
		}),
	},
	methods: {
		...mapMutations({
			setKey: "tree/setKey",
			setCopyQuery: "tree/setCopyQuery",
            changeFlagConstructor: "property/changeFlagConstructor"
		}),
		closeAll() {
			this.treeKey++;
			this.expanded = !this.expanded;
		},
        tabClick(isnormal) {
            this.changeFlagConstructor({ name: 'loadingProperty', value: true });
            this.setKey();
            this.isnormal = isnormal;
        }
	},
	created() {
		this.mobile = window.document.documentElement.clientWidth <= 960;
	}
};
</script>
